import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Rotate14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.75 1H1.25V5.75H6V4.25H3.75951C4.54007 3.33114 5.70209 2.75 7.00003 2.75C9.34724 2.75 11.25 4.65279 11.25 7C11.25 9.34721 9.34724 11.25 7.00003 11.25C5.61007 11.25 4.37599 10.5835 3.59934 9.54957L2.39999 10.4504C3.44776 11.8454 5.11836 12.75 7.00003 12.75C10.1757 12.75 12.75 10.1756 12.75 7C12.75 3.82436 10.1757 1.25 7.00003 1.25C5.31585 1.25 3.80076 1.97472 2.75 3.12704V1Z'
      fill='currentColor'
    />
  </Svg>
);

Rotate14.displayName = 'Rotate14';
export default Rotate14;
